module.exports = __webpack_public_path__ + "static/media/stingy.77dbb860.webp";